var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTexts = function SvgTexts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 12,
    x: 31,
    y: 53,
    fill: "#2F68D1",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    d: "M37 43a6 6 0 0 0-6-6H10a6 6 0 0 0 0 12h21a6 6 0 0 0 6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD2A8",
    d: "M45 11a6 6 0 0 0-6-6H10a6 6 0 1 0 0 12h29a6 6 0 0 0 6-6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 12,
    x: 20,
    y: 21,
    fill: "#6C9BF1",
    rx: 6
  })));
};
export default SvgTexts;